/**
 * Utilities for building navigation context data
 */

import { getCurrentSection, getNavigationContext, getRelatedPages } from './helpers';

import type { NavigationContext, RouteInfo, RouteListItem, RoutesListContext } from './types';

/**
 * Build navigation context for the current page
 */
export function buildNavigationContext(pathname: string, allRoutes: RouteInfo[]): NavigationContext {
  const currentSection = getCurrentSection(pathname);
  const relatedPages = getRelatedPages(pathname, allRoutes);
  const navContext = getNavigationContext(pathname, allRoutes);

  return {
    currentPath: pathname,
    currentSection,
    currentRoute: navContext.current,
    parent: navContext.parent,
    siblings: navContext.siblings,
    children: navContext.children,
    relatedPages,
    sections: Array.from(new Set(allRoutes.map((r) => r.section))).sort(),
    totalRoutes: allRoutes.length,
  };
}

/**
 * Build static routes list context
 */
export function buildRoutesListContext(allRoutes: RouteInfo[]): RoutesListContext {
  const routesList: RouteListItem[] = allRoutes.map((r) => ({
    path: r.path,
    label: r.label,
    section: r.section,
  }));

  return {
    routes: routesList,
    routeCount: routesList.length,
  };
}
